import cc from 'classcat';
import { useLayoutEffect, useState } from 'react';

import { isClient } from '#src/lib/utils.mjs';

import { H1 } from './Headings.js';
import styles from './HeadingAnimation.scss';

const animatedHeaderText = [
  'Lose weight',
  'Get healthier',
  'Reverse aging',
  'Sleep better',
  'Exercise more',
  'Eat better',
  'Get stronger',
  'Quit smoking',
  'Boost memory',
];

export function HeadingAnimation() {
  const [activePhrase, setActivePhrase] = useState(0);

  if (isClient)
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useLayoutEffect(() => {
      const interval = setTimeout(() => {
        setActivePhrase(
          (prevPhrase) => (prevPhrase + 1) % animatedHeaderText.length
        );
      }, 2500);

      return () => {
        clearTimeout(interval);
      };
    });

  return (
    <div className={styles.animatedHeaderTextWrapper}>
      {animatedHeaderText.map((phrase, i) => (
        <H1
          key={i}
          className={cc([
            styles.animatedHeaderPhrase,
            activePhrase === i ? styles.rotateIn : styles.rotateOut,
          ])}
        >
          {phrase}
        </H1>
      ))}
    </div>
  );
}
